

// Third-party imports
import { Amplify } from 'aws-amplify';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Local component imports 
import { MockAuthProvider } from '@/components/auth/MockAuthContext';
import { AuthProvider } from '@/components/auth/RealAuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AuthPages } from './components/auth/AuthPages';
import MLRPage from '@/components/MLRPage';
import PersonaLibraryPage from '@/components/PersonaLibraryPage';
import ChatPage from '@/components/ChatPage';
import HomePage from '@/components/HomePage';
import AssetsPage from '@/components/AssetsPage';
import ProjectsPage from '@/components/ProjectsPage';
// Config imports
import { awsConfig } from '@/components/auth/cognitoConfig';

// Styles
import './App.css'
import CommentValidationPage from './components/CommentValidationPage';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsConfig.Auth.userPoolId,
      userPoolClientId: awsConfig.Auth.userPoolWebClientId,
    }
  }
});

function App() {
  const useMockAuthentication = import.meta.env.VITE_USE_MOCK_AUTH === 'true';

  const Provider = useMockAuthentication ? MockAuthProvider : AuthProvider;

  return (
    <BrowserRouter>
      <Provider>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<AuthPages />} />
          <Route path="/mlr" element={
              <ProtectedRoute>
                <MLRPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/persona-library"
            element={
              <ProtectedRoute>
                <PersonaLibraryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat-with-persona"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comment-validation"
            element={
              <ProtectedRoute>
                <CommentValidationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/homepage"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assets"
            element={
              <ProtectedRoute>
                <AssetsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-projects"
            element={
              <ProtectedRoute>
                <ProjectsPage />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          /> */}
          {/* Add more routes as needed */}
        </Routes>
      </Provider>
    </BrowserRouter>
  );
}

export default App;